import {FormHookDefaults} from "@/components/_Shared/Form/Interfaces/BasePropFormHookDefaults.ts";
import {FieldValues} from "react-hook-form";
import {GenericForm, GenericFormBGContainer} from "@/components/GenericForm.tsx";
import {Divider} from "@/components/misc.tsx";
import {Input} from "@/components/_Shared/Form/Inputs/Input.tsx";
import {FormChild, FormGroup} from "@/components/_Shared/Form/Containers/FormGroup.tsx";
import {Button} from "@/components/_Shared/Button.tsx";
import {Submit} from "@/components/_Shared/Form/Buttons/Submit.tsx";
import {useNavigate} from "react-router-dom";

type ClientBaseProps<TFormValues extends FieldValues> = {
    method: "POST" | "PUT"
} & FormHookDefaults<TFormValues>

export function ClientFormBase<TFormValues extends FieldValues>({
    register, errors,
    onSubmit, method, isProcessing
    }: ClientBaseProps<TFormValues>) {
    const navigate = useNavigate()

    return(
        <GenericForm form_id={"client_form"} onSubmit={onSubmit}>
            <GenericFormBGContainer>
                <h2 className={"text-2xl font-bold"}>{method == "POST" ? "Create" : "Update"} Client</h2>

                <Divider />

                <Input label={"Name"} name={"name"} type={"text"} register={register}/>
                {errors.name && <p className={"text-red-500"}>{String(errors.name.message)}</p> }

                <FormGroup>
                    <FormChild>
                        <Input label={"Email"} name={"email"} type={"email"} register={register} />
                        {errors.email && <p className={"text-red-500"}>{errors.email.message} </p>}
                    </FormChild>

                    <FormChild>
                        <Input label={"Phone Number"} name={"phone_number"} type={"text"} register={register} />
                        {errors.phone_number && <p className={"text-red-500"}>{errors.phone_number.message} </p>}
                    </FormChild>
                </FormGroup>

                <FormGroup>
                    <FormChild>
                        <Input label={"Street Address"} type={"text"} name={"street_address"} register={register}/>
                        {errors.street_address && <p className={"text-red-500"}>{String(errors.street_address.message)}</p> }
                    </FormChild>

                    <FormChild>
                        <Input label={"City"} type={"text"} name={"city"} register={register}/>
                        {errors.city && <p className={"text-red-500"}>{errors.city.message}</p> }
                    </FormChild>
                </FormGroup>

                <FormGroup>
                    <FormChild>
                        <Input label={"State"} type={"text"} name={"state"} register={register}/>
                        {errors.state && <p className={"text-red-500"}>{errors.state.message}</p> }
                    </FormChild>

                    <FormChild>
                        <Input label={"Postal Code"} name={"postal_code"} type={"text"} register={register} />
                        {errors.postal_code && <p className={"text-red-500"}>{errors.postal_code.message} </p>}
                    </FormChild>
                </FormGroup>

                <FormGroup>
                   <Button onClick={() => navigate("/client/list")}>Cancel</Button>
                    <Submit isSubmitting={isProcessing} label="Submit" />
                </FormGroup>
            </GenericFormBGContainer>
        </GenericForm>
    )
                                       }